import { render, staticRenderFns } from "./dsOrder.vue?vue&type=template&id=3e5ebadd&scoped=true"
import script from "./dsOrder.vue?vue&type=script&lang=js"
export * from "./dsOrder.vue?vue&type=script&lang=js"
import style0 from "./dsOrder.vue?vue&type=style&index=0&id=3e5ebadd&prod&lang=less&scoped=true"
import style1 from "./dsOrder.vue?vue&type=style&index=1&id=3e5ebadd&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5ebadd",
  null
  
)

export default component.exports